import { View } from 'react-native';
import { offsetX, offsetY, styles } from './DiscountMilestone.styles';
import TextLato from '../../../text/text-lato/TextLato';
import { Icon } from '../../../icon/Icon';
import { ICON_NAMES } from '../../../icon/icon.helper';
import Animated, { SharedValue } from 'react-native-reanimated';
import Confetti from '../../confetti/Confetti';
import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { useStore } from 'src/contexts/StoreContext';
import { useDiscountMilestoneLogic } from './DiscountMilestone.logic';

export const DiscountMilestone = ({
  item,
  index,
  isMobile,
  steps,
  progressSV,
  anyMilestoneShowingCheckSV,
  lastReachedMilestone,
  showAnimationMilestone = false,
}: {
  item: DiscountScale;
  index: number;
  isMobile?: boolean;
  steps: number;
  progressSV: SharedValue<number>;
  anyMilestoneShowingCheckSV: SharedValue<boolean>;
  lastReachedMilestone?: number | null;
  showAnimationMilestone?: boolean;
}) => {
  const { i18n } = useStore();

  const {
    left,
    milestoneAnimatedStyle,
    textAnimatedStyle,
    checkAnimatedStyle,
    confettiLayout,
    showConfetti,
    onLayout,
  } = useDiscountMilestoneLogic(index, steps, progressSV, anyMilestoneShowingCheckSV, lastReachedMilestone);

  return (
    index > 0 && (
      <View
        key={'Milestone' + index}
        style={[!isMobile ? styles.milestoneWrapper : styles.milestoneWrapperMobile, { left: `${left}%` }]}
        onLayout={onLayout}
      >
        {confettiLayout && showAnimationMilestone && (
          <Confetti
            count={250}
            width={confettiLayout.width}
            height={confettiLayout.height}
            milestoneReached={showConfetti}
            duration={1000}
            offsetY={offsetY}
            offsetX={offsetX}
          />
        )}
        <Animated.View style={[styles.milestone, milestoneAnimatedStyle]}>
          <Animated.Text style={[textAnimatedStyle, styles.textNotActive]}>
            <TextLato style={styles.textPercentage}>-</TextLato>
            {item.discount}
            <TextLato style={styles.textPercentage}>%</TextLato>
          </Animated.Text>
          <Animated.View style={[styles.checkIcon, checkAnimatedStyle]}>
            <Icon name={ICON_NAMES.Check} color="white" width={10} height={10} />
          </Animated.View>
        </Animated.View>
        <TextLato style={styles.photos}>
          {i18n.t('discounts-table:photo', {
            photos: item.from,
          })}
        </TextLato>
      </View>
    )
  );
};
